import React, { useEffect } from "react";


const TableFooter = ({ range, setPage, page, slice }) => {
  useEffect(() => {
    if (slice.length < 1 && page !== 1) {
      setPage(page - 1);
    }
  }, [slice, page, setPage]);

  const maxButtons = 10;
  const totalPages = range.length;

  const start = Math.floor((page - 1) / maxButtons) * maxButtons;
  const visibleRange = range.slice(start, start + maxButtons);

  return (
    <div className="flex flex-row flex-wrap gap-1 w-full h-[2.5rem] items-center justify-center text-sm">
      
      {/* Botón Anterior bloque de 10 */}
      {start > 0 && (
        <button
          className="w-8 h-8 rounded-md border border-gray-300 hover:bg-gray-200"
          onClick={() => setPage(start)}
        >
        <label>{'<<'}</label>
        </button>
      )}
      {/* Números de página visibles */}
      {visibleRange.map((el, index) => (
        <button
          key={index}
          className={`w-8 h-8 rounded-md text-sm ${
            page === el
              ? "bg-default text-white"
              : "border border-gray-300 hover:bg-gray-100"
          }`}
          onClick={() => setPage(el)}
        >
          {el}
        </button>
      ))}

      {/* Botón Siguiente bloque de 10 */}
      {start + maxButtons < totalPages && (
        <button
          className="w-8 h-8 rounded-md border border-gray-300 hover:bg-gray-200"
          onClick={() => setPage(start + maxButtons + 1)}
        >
          <label>{'>>'}</label>
        </button>
      )}
    </div>
  );
};

export default TableFooter;
